import React, { PropsWithChildren } from 'react'

import { Spinner } from './Spinner'

import styles from './GridLoading.module.scss'

interface Props {
  isLoading: boolean
}

export const GridLoading: React.FC<PropsWithChildren<Props>> = ({ isLoading, children }) => {
  return (
    <div className={styles.gridWrapper}>
      {isLoading && (
        <div className={styles.spinnerWrapper}>
          <Spinner modal={false} />
        </div>
      )}
      {children}
    </div>
  )
}
